import React from "react";
import FanctionalityTable from "../../../shared/FunctionalityTable/FunctionalityTable";

function FunctionalityNewUser(props) {
  return <FanctionalityTable></FanctionalityTable>;
}

export default FunctionalityNewUser;
